export class RolesController {
    constructor(axios) {
        this.axios = axios;
    }
    async find() {
        try {
            const response = await this.axios.get("/roles");
            return response.data;
        }
        catch (e) {
            throw e;
        }
    }
}
